import { ComputedRef, InjectionKey, Reactive } from 'vue';

import {
  EcosystemFieldMappings,
  EcosystemFieldsPush,
  IntegrationProfileType,
  PartnerOption,
} from '@/types/integration_profiles';
import { Mapping } from '@/types/integrations';

export const ProvidedTrayState: InjectionKey<
  Reactive<{
    isEnabled: boolean;
    oppPush: boolean;
    customObjectPush: boolean;
    partnerFieldMappingsPush: boolean;
    accountPush: EcosystemFieldsPush;
    ecosystemMaps: EcosystemFieldMappings;
    profileType?: IntegrationProfileType;
    profileId?: string;
    saveTrayConfig: () => Promise<void>;
    partnerFieldMappings: Mapping[];
    sharedPartnerFields?: PartnerOption[];
  }>
> = Symbol('TrayState');

export const ProvidedIsTrayUpdateRequired: InjectionKey<ComputedRef<boolean>> =
  Symbol('IsTrayUpdateRequired');
